<template>
  <div class="npubsub-portal">
    <div class="background pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">{{$t('dataRideSupport.banner1.title')}}</h1>
            <h2 class="subheader">{{$t('dataRideSupport.banner1.subTitle')}}</h2>
            <p class="text" v-html="$t('dataRideSupport.banner1.text')"></p>
          </div>
          <div class="banner-1">
            <img v-lazy="'/static/img/npubsub/dataRide-support-banner-1.png'">
          </div>
        </div>
      </div>
    </div>
    <div class="background pb-rem pt-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="banner-3 column" style="max-width: 400px">
            <div class="flex justify-between">
              <div class="col-6 icon-title-item">
                <font-awesome-icon :icon="['fas','wallet']" size="5x" style="color:#1791f2;"/>
                <span>{{$t('dataRideSupport.banner2.iconText1')}}</span>
              </div>
              <div class="col-6 icon-title-item">
                <font-awesome-icon :icon="['fas','share-alt']" size="5x" style="color:#3752c2;"/>
                <span>{{$t('dataRideSupport.banner2.iconText2')}}</span>
              </div>

            </div>
          </div>
          <div class="details-1" style="max-width: 500px">
            <h1 class="title">{{$t('dataRideSupport.banner2.title')}}</h1>
            <p class="text" v-html="$t('dataRideSupport.banner2.text')"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">{{$t('dataRideSupport.banner3.title')}}</h1>
            <h1 class="subheader">{{$t('dataRideSupport.banner3.subTitle')}}</h1>
            <p class="text" v-html="$t('dataRideSupport.banner3.text')"></p>
          </div>
          <div class="banner-1">
            <img v-lazy="'/static/img/npubsub/dataRide-support-banner-2.png'" style="height: 300px;width: inherit;">
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="common-title">{{$t('dataRideSupport.step1.title')}}</div>
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">
              <img v-lazy="'/static/img/npubsub/dataRide-support-step1.png'" style="height: 60px;">
            </h1>
            <div class="text" v-html="$t('dataRideSupport.step1.text')"></div>
          </div>
          <div class="banner-3 flex" style="width:100%;flex-grow:0;height: 400px;">
            <div v-html="code1" v-highlight style="width:100%;height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">
              <img v-lazy="'/static/img/npubsub/dataRide-support-step2.png'" style="height: 60px;">
            </h1>
            <div class="text" v-html="$t('dataRideSupport.step2.text')"></div>
          </div>
          <div class="banner-3 flex" style="width:100%;flex-grow:0;height: 400px;">
            <div v-html="code2" v-highlight style="width:100%;height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="details-1">
            <h1 class="title">
              <img v-lazy="'/static/img/npubsub/dataRide-support-step3.png'" style="height: 60px;">
            </h1>
            <div class="text" v-html="$t('dataRideSupport.step3.text')"></div>
          </div>
          <div class="banner-3 flex" style="width:100%;flex-grow:0;height: 400px;">
            <div v-html="code3" v-highlight style="width:100%;height:400px;"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="banner-1">
            <img v-lazy="'/static/img/npubsub/dataRide-support-banner-3.png'" style="height: 300px;width: inherit;">
          </div>
          <div class="details-1">
            <h1 class="title">{{$t('dataRideSupport.banner4.title')}}</h1>
            <p class="text" v-html="$t('dataRideSupport.banner4.text')"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="background pt-rem pb-rem">
      <div class="nkn-container">
        <div class="flex">
          <div class="learn-more">
            <h1 class="title">{{$t('learnMore')}}</h1>
          </div>
          <div class="list">
            <a v-if="$i18n.locale ==='zh'" href="https://forum.nkn.org/t/nkn-pub-sub/2006" target="_blank"><img v-lazy="'/static/img/npubsub/dataRide-support-banner-4.png'" style="height: 160px;"></a>
            <a v-else href="https://forum.nkn.org/t/chat-based-customer-support-built-on-npubsub/2019" target="_blank"><img v-lazy="'/static/img/npubsub/dataRide-support-banner-4.png'" style="height: 160px;"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex'

  export default {
    components: {},
    computed: {
      ...mapGetters({
        lang: 'getLang'
      })
    },
    data() {
      return {
        code1: `<pre style="height:100%"><code style="height:100%" class="language-javascript">import Wallet from 'nkn-wallet'
// Create a new wallet, in order to manage private topic
let wallet = Wallet.newWallet('PASSWORD')
// If there is existing wallet
// let wallet = Wallet.restoreWalletBySeed('SEED','PASSWORD')
let seed = wallet.getSeed() // save seed

// Subscribe to private topic
let address = \`$\{wallet.getPublicKey()\}\`
let topic = \`TOPIC.$\{address\}\`


// Add private group member addresses. Please keep the size of array for each page within the limit of meta data max size, and you might need multiple calls for large group.
wallet.subscribe(topic, 400000, \`__0__.__permission__\`, JSON.stringify({accept: [{addr:'ADDRESS1'},{addr:'ADDRESS2'},/*...*/]}))
wallet.subscribe(topic, 400000, \`__1__.__permission__\`, JSON.stringify({accept: [{addr:'ADDRESS3'},{addr:'ADDRESS3'},/*...*/]}))
// ......
</code></pre>`,
        code2: `<pre style="height:100%"><code style="height:100%" class="language-javascript">import Client from 'nkn-multiclient'

let client = Client()
// Get the list of addresses of customer support staff
let getSubscribers = async function (topic, owner) {
  let i = 0
  let members = [owner]
  while (true) {
    // Use _i_ as index, query all pages
    let res = await client.clients[0].getSubscription(\`$\{topic\}\`, \`__$\{i\}__.__permission__.$\{owner\}\`)
    let meta
    try {
      meta = JSON.parse(res.meta)
    } catch (e) {
      break
    }
    if (meta && meta.accept && meta.accept.length > 0) {
      // If the group is not empty, merge all data
      meta.accept.forEach(x=> members.push(x.addr))
    } else {
      // Quit if the private group is empty
      break
    }
    i++
  }
  return members
}

</code></pre>`,
        code3: `<pre style="height:100%"><code style="height:100%" class="language-javascript">async function main (){
  // Get the list of addresses of customer support staff
  let dests = await getSubscribers(topic, address)
  // Package the data into private chat format compatible with D-Chat
  let data = {
    contentType: 'text',
    id: uuidv4(), // import uuidv4 from 'uuid/v4'
    content: 'hello world',
    isPrivate: true,
    timestamp: new Date().getTime()
  }

  client.on('connect', function () {
    // Group send message to private group members
    client.send(dests, JSON.stringify(data))
  })

  // Receive customer support message
  client.on('message', function (src, data) {
    // src: sender address， data: received message
    let message = JSON.parse(data)
    if (message.contentType === 'text') {
      // TODO ... Display message to customer support staff UI
      // Package into an Acknowledgement message that is compatible with D-Chat
      let receipt = {
        contentType: 'receipt',
        id: uuidv4(), // import uuidv4 from 'uuid/v4'
        timestamp: new Date().getTime(),
        targetID: message.id,
        isPrivate: true
      }
      // Send acknowledgement message
      client.send(dests, JSON.stringify(receipt))
    }
  })
}
main()

</code></pre>`

      }
    },
    metaInfo() {
      if (this.$i18n.locale === 'zh') {
        return {
          title: 'dataRide',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          attribute: '',
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'dataRide。'
            }
          ]
        }
      } else {
        return {
          title: 'dataRide',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'dataRide.'
            }
          ]
        }
      }

    }
  }
</script>

<style lang="scss" scoped>
  .npubsub-portal {
    position: relative;
  }

  .nkn-container {
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .details-1 {
    max-width: 400px;
    width: 100%;
    flex-shrink: 0;
    align-self: center;
    word-break: break-word;
    .title {
      font-size: 1.2rem;
      color: #0096FF;
      font-weight: 500;
    }

    .subheader {
      font-size: 0.9rem;
      color: #0096FF;
      font-weight: 500;
    }

    .text {
      font-size: 0.75rem;
      color: #24397D;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 1rem;
      margin-top: .75rem;
    }
  }

  .details-2 {
    width: 50%;
    flex-shrink: 0;
    align-self: center;
    @media screen and (max-width: 768px) {
      width: 100%;
    }

    .title {
      font-size: 1.2rem;
      color: #0096FF;
      font-weight: 500;
    }

    .subheader {
      font-size: 0.9rem;
      color: #0096FF;
      font-weight: 500;
    }

    .text {
      font-size: 0.75rem;
      color: #24397D;
      font-weight: 400;
      margin-bottom: 10px;
      line-height: 1rem;
      margin-top: .75rem;
    }
  }

  .banner-1 {
    flex-shrink: 1;
    max-width: 500px;

    img {
      width: 100%;
    }
  }

  .banner-2 {
    display: flex;
    max-width: 600px;
    width: 100%;
    align-items: center;
    justify-content: space-around;

    div {
      flex-shrink: 1;
      flex-grow: 0;
      margin-right: 10px;

      img {
        display: block;
        height: 100%;
        width: 100%;

      }
    }
  }

  .banner-3 {
    display: flex;
    max-width: 600px;
    width: 100%;
    align-items: center;
    justify-content: space-around;
  }

  .icon-title-item {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    width: 150px;
    span {
      margin-top: 1rem;
    }
  }

  .learn-more{
    margin-right: 50px;
  }
  .list{
  flex-grow: 1;
  }

  .aqi-logo {
    width: auto;
    height: 70px;
  }

  .mp-logo {
    width: auto;
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/DataRideSupport.vue